import type { Hotels, RoomType } from '@entities/avail'
import { parseAsBoolean, useQueryState } from 'nuqs'
import type React from 'react'
import { createContext, useContext, useEffect, useState } from 'react'

export interface AvailVipData {
  room: RoomType | undefined
  hotel: Hotels | null
  checkIn: any
  checkOut: any
}

interface AvailVipContextData {
  toggleAvailVipModal: () => void
  setData: ({ checkIn, checkOut, hotel, room }: AvailVipData) => void
  isOpen: boolean
  reservationVipData: AvailVipData | undefined
}

const AvailVipContext = createContext<AvailVipContextData>(
  {} as AvailVipContextData,
)

function AvailVipProvider({
  children,
}: React.PropsWithChildren<object>): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)
  const [timesUp] = useQueryState('timesUp', parseAsBoolean)
  const [reservationVipData, setReservationVipData] = useState<AvailVipData>()

  function toggle(): void {
    setIsOpen(!isOpen)
  }

  function setData({ room, hotel, checkIn, checkOut }: AvailVipData): void {
    setReservationVipData({
      hotel,
      room,
      checkIn,
      checkOut,
    })
    toggle()
  }

  useEffect(() => {
    if (timesUp === true) {
      setIsOpen(false)
    }
  }, [timesUp])

  return (
    <AvailVipContext.Provider
      value={{
        isOpen,
        toggleAvailVipModal: toggle,
        reservationVipData,
        setData,
      }}
    >
      {children}
    </AvailVipContext.Provider>
  )
}

function useAvailVip(): AvailVipContextData {
  const context = useContext(AvailVipContext)

  if (!context) {
    throw new Error('useAvailVip must be used within an AvailVipProvider')
  }

  return context
}

export { AvailVipProvider, useAvailVip }
